document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.new-in-store-slider-wrapper').forEach(slider => {
    const track = slider.querySelector('.new-in-store-slider-track');
    const prev = slider.querySelector('.new-in-store-prev');
    const next = slider.querySelector('.new-in-store-next');

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -300, behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: 300, behavior: 'smooth' });
    });
  });
});
